<div class="note-btn-wrapper">
  <!-- orange triangle -->
  @if (triangle) {
    <svg
      [class.disabled]="disabled"
      width="14"
      height="14"
      (click)="onTriangleClick($event)"
      [dtHoverPopover]="noteHover"
      [dtHoverPopoverDisableClick]="true"
      [dtHoverPopoverDisabled]="comment | richTextEmpty"
      [dtHoverPopoverPosition]="'right'"
      [dtHoverPopoverDelay]="500"
    >
      <polygon
        class="poly"
        [class.team]="hasTeamComments"
        points="0,0 14,0 14,14"
        [class.is-empty]="comment | richTextEmpty"
        [class.dark-background]="darkBackground"
      ></polygon>
    </svg>
  }
</div>

<dt-modal #modalLargeCommentField (modalClose)="close()" [showFooter]="false" [flexContent]="true" [contentPadding]="false">
  <ng-template #title>
    @if (mainTitle) {
      {{ mainTitle }}
    } @else {
      <ng-container i18n>Notiz</ng-container>
    }
  </ng-template>
  <ng-template #subtitle>
    @if (modalCaption) {
      {{ modalCaption }}
    }
  </ng-template>
  <ng-template #content>
    @if (!twoComments) {
      <dt-rich-text-editor
        [(text)]="comment"
        (textChange)="onCommentChange()"
        [modalPadding]="true"
        [readonly]="readonly"
        (click)="noteModalClick.emit()"
      ></dt-rich-text-editor>
    } @else {
      <mat-accordion multi="true">
        <mat-expansion-panel [expanded]="firstOpen">
          <mat-expansion-panel-header>
            <ng-container> {{ modalSubTitle }}</ng-container>
          </mat-expansion-panel-header>
          <div class="expansion-content">
            <dt-rich-text-editor
              [(text)]="comment"
              (textChange)="onCommentChange()"
              [modalPadding]="true"
              [readonly]="readonly"
              (click)="noteModalClick.emit()"
            ></dt-rich-text-editor>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="secondOpen">
          <mat-expansion-panel-header>
            <ng-container> {{ modalSecondSubTitle }}</ng-container>
          </mat-expansion-panel-header>
          <div class="expansion-content">
            <dt-rich-text-editor
              [(text)]="secondComment"
              (textChange)="onCommentChange()"
              [modalPadding]="true"
              [readonly]="readonly"
              (click)="noteModalClick.emit()"
            ></dt-rich-text-editor>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    }
    <ng-content select="[additional-modal-content]"></ng-content>
  </ng-template>
</dt-modal>

<ng-template #noteHover>
  <div class="note-hover-container mat-elevation-z3">
    <dt-rich-text-editor
      [withToolbar]="false"
      [(text)]="comment"
      (textChange)="onCommentChange()"
      [readonly]="readonly"
    ></dt-rich-text-editor>
  </div>
</ng-template>
